module.exports = __webpack_public_path__ + "img/ddtd.5355fcfe.png";